var googleMaps = {
    id: '',
    map: null,
    markers: [],
    mapMarkers: [],
    infoWindows: [],
    infoWindowClickCallback: 'default',

    init: function(id) {
        this.id = id;
        return this;
    },

    markerClickEvent: function(callback) {
        this.infoWindowClickCallback = callback;
        return this;
    },

    getMarkers: function(callback) {
        if(typeof(callback) == 'function') callback(this);
        return this;
    },

    initialize: function(mapOptions) {
        var _ = this;

        mapOptions = Object.assign(this.defaultOptions(), (mapOptions === undefined) ? {} : mapOptions);

        this.map = new google.maps.Map(document.getElementById(this.id), mapOptions);

        for (var i = 0; i < this.markers.length; i++) {
            var marker = this.markers[i];
            console.log(marker.imageSize);
            var image = {
                url: marker.image,
                scaledSize: new google.maps.Size(marker.imageSize[0], marker.imageSize[1])
            }

            var mapMarker = new google.maps.Marker({
                position: new google.maps.LatLng(marker.lat, marker.long),
                map: _.map,
                title: marker.naam,
                optimized: false,
                icon: image
            });

            _.mapMarkers[i] = mapMarker;

            if(marker.content != undefined) {
                _.infoWindows[i] = new google.maps.InfoWindow({
                    content: marker.content
                });

                google.maps.event.addListener(mapMarker, 'click', function () {
                    for (var x = 0; x < _.markers.length; x++) {
                        if (_.infoWindows[x]) {
                            _.infoWindows[x].close();
                        }
                    }

                    if(_.infoWindowClickCallback == 'default') {
                        _.infoWindows[_.mapMarkers.indexOf(this)].open(_.map, this);
                    }else if(_.infoWindowClickCallback !== false) {
                        _.infoWindowClickCallback(_, _.infoWindows[_.mapMarkers.indexOf(this)]);
                    }
                });

            }
        }
        return this;
    },

    defaultOptions: function() {
        return {
            center: new google.maps.LatLng(52.0841037, 4.9424092),
            zoom: 9,
            maxZoom : 0,
            minZoom : 0
        };
    }
}
